<template>
  <div class="row">
    <div class="small-4 small-offset-4 columns">
      <h3>Új jelszó beállítása</h3>
    </div>
    <div class="small-4 small-offset-4 columns">
      <form class="ui form">
        <div class="field">
          <label>Jelszó *</label>
          <input v-model="pwd"
                 name="pwd"
                 type="password">
        </div>
        <div class="field">
          <label>Jelszó ismét *</label>
          <input v-model="pwd2"
                 name="pwd2"
                 type="password">
        </div>
      </form>
      <button class="ui primary button"
              @click="saveNewPwd">Mentés
      </button>
    </div>
  </div>
</template>

<script>
import config from '@/config'
import utils from '@/utils'
import notify from '@/notify'
import sha1 from 'js-sha1'

export default {
  /* eslint-disable */
  data () {
    return {
      token: null,
      email: null,
      pwd: '',
      pwd2: '',
    }
  },
  methods: {
    saveNewPwd () {
      if (this.token && this.email) {
        if (this.pwd.length >= 6) {
          if (this.pwd === this.pwd2) {
            this.$http({
              url: config.SERVER_DOMAIN + '/api/guest/forgottenpasswordset',
              method: 'POST',
              params: { passwordToken: this.token, email: this.email, newPwd: sha1(this.pwd) },
            }).then(response => {
              console.log('--- pwd changes success')
              // eslint-disable-next-line
              notify.success('Sikeres jelszó módosítás')
            }, error => {
              utils.httpError(error)
              // this.$router.push('Reservation')
            }).finally(() => {
              this.$router.push('Reservation')
            })
          } else {
            notify.warning('A két jelszó nem egyezik!')
          }
        } else {
          notify.warning('A jelszónak minimum 6 karakterből kell állnia!')
        }
      } else {
        notify.warning('Hibás jelszó kérő link!')
        this.$router.push('Reservation')
      }
    },
  },
  created: function () {
    let query = this.$route.query
    if (query.hasOwnProperty('t') && query.hasOwnProperty('email')) {
      this.token = query.t
      this.email = query.email
    } else {
      notify.warning('Hibás jelszó kérő link!')
      this.$router.push('Reservation')
    }
  },
}
</script>

<style scoped>
.row {
  margin-top: 1rem
}

.button {
  margin-top: 1rem
}
</style>
